import React, { FC, useEffect, useState } from 'react'

import { where } from 'firebase/firestore'

import ViewsLoader from '../../../../../components/loader/ViewsLoader'
import EventReportsReport from './components/EventReportsReport/EventReportsReport'
import { EventResultsReport } from './components/EventResultsReport/EventResultsReport'

import { EventFeesModel } from '../../../../../models/event-fees/event-fees.model'
import { TEventRegisteredUsers } from '../../../../../models/event-registered-users/event-registered-users.interface'
import { EventRegisteredUsersModel } from '../../../../../models/event-registered-users/event-registered-users.model'
import { IEventInterface } from '../../../../../models/events/event.interface'
import { EventModel } from '../../../../../models/events/event.model'
import { IHorseData } from '../../../../../models/horse/horse.interface'
import { HorseModel } from '../../../../../models/horse/horse.model'
import { IRegistrationByDayInterface } from '../../../../../models/registrations-by-day/registrationByDay.interface'
import { IUserInterface } from '../../../../../models/users/user.interface'

import FirestoreService from '../../../../../services/firestoreService'
import RegistrationDyDayService from '../../../../../services/firebase-service/registration-by-day/RegistrationDyDayService'

import useToasterHelper from '../../../../../helpers/ToasterHelper'
import { getConvertedData } from '../../../../../models/interface.helper'

import { IEventReviewPublish } from '../../../../../models/event-review-publish/event-review-publish.interface'
import { EventReviewPublishModel } from '../../../../../models/event-review-publish/event-review-publish.model'
import { UserModel } from '../../../../../models/users/user.model'
import { IEventScheduleInterface } from '../../../../../models/event-scheduling/event-scheduling.interface'
import { IScoreCardInterface } from '../../../../../models/score-cards/score-cards.interface'
import { ScoreCardModel } from '../../../../../models/score-cards/score-cards.model'
import { RiderTeamMemberModel } from '../../../../../models/rider-team-member/riderTeamMember.model'
import { IRiderTeamMemberInterface } from '../../../../../models/rider-team-member/riderTeamMember.interface'

import { CONST } from '../../../../../const/const'
import { MESSAGES_CONST } from '../../../../../const/messages-const'

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

export type IReports = 'Event Reports' | 'Event Results'

interface ManageClinicNOtherReportsTabProps {
  eventId: string
}

const ManageClinicReportsRoot: FC<ManageClinicNOtherReportsTabProps> = ({ eventId }) => {
  const toastFunctions = useToasterHelper()

  const [activeOption, setActiveOption] = useState<IReports>('Event Reports')
  const [event, setEvent] = useState<IEventInterface | null>(null)
  const [riderTeamMembers, setRiderTeamMembers] = useState<IRiderTeamMemberInterface[]>([])
  const [eventRegisteredUsers, setEventRegisteredUsers] = useState<TEventRegisteredUsers[] | null>(
    null
  )
  const [registeredUsersByDay, setRegisteredUsersByDay] = useState<IRegistrationByDayInterface[]>(
    []
  )
  const [registrationFees, setRegistrationFees] = useState<any>(null)
  const [hunterJumperScoreCards, setHunterJumperScoreCards] = useState<
    IScoreCardInterface[] | null
  >(null)
  const [scheduleBy, setScheduleBy] = useState<'class' | 'rider'>('class')
  const [horses, setHorses] = useState<IHorseData[] | null>(null)
  const [customScheduling, setCustomScheduling] = useState<
    IEventScheduleInterface['custom'] | null
  >(null)
  const [eventReviewPublish, setEventReviewPublish] = useState<IEventReviewPublish | null>(null)
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState<IUserInterface[]>([])

  const getAllData = async () => {
    setLoading(true)

    try {
      const riderTeamMembers_: IRiderTeamMemberInterface[] = []
      const eventRegisteredUsers_: TEventRegisteredUsers[] = []
      const horsesInDb: IHorseData[] = []
      const usersInDb: IUserInterface[] = []
      const scoreCards: IScoreCardInterface[] = []

      const eventReviewPublishSnapShot = await FirestoreService.getItem(
        COLLECTIONS.EVENT_REVIEW_PUBLISH.NAME,
        eventId
      )

      let eventReviewPublish_: IEventReviewPublish | null = null
      if (eventReviewPublishSnapShot.exists()) {
        eventReviewPublish_ = EventReviewPublishModel.fromFirestoreDoc(
          eventReviewPublishSnapShot
        ).toObject()
        setEventReviewPublish(eventReviewPublish_)
      }

      // Get scheduleBy and custom from eventReviewPublish instead of separate fetch
      const scheduleByDataPoint = eventReviewPublish_?.EventSchedule?.scheduleBy ?? 'class'
      const custom = eventReviewPublish_?.EventSchedule?.custom ?? []

      setScheduleBy(scheduleByDataPoint)
      setCustomScheduling(custom)
      setScheduleBy(scheduleByDataPoint)
      setCustomScheduling(custom)

      // get hunter-jumper score cards so we can look up metadata related to the hunter jumper score cards on the USEF export

      const scoreCardsSnaps = await FirestoreService.filterItems(COLLECTIONS.SCORE_CARDS.NAME, [
        where(COLLECTIONS.SCORE_CARDS.FIELDS.TYPE.KEY, '==', 'hunter-jumper'),
      ])

      scoreCardsSnaps.forEach((doc) => {
        const item = ScoreCardModel.fromFirestoreDoc(doc).toObject()
        scoreCards.push(item)
      })

      setHunterJumperScoreCards(scoreCards)

      const eventsSnaps = await FirestoreService.getItem(COLLECTIONS.EVENTS.NAME, eventId)
      const event_ = getConvertedData(EventModel.fromFirestoreDoc(eventsSnaps).toObject())

      const riderReamMembersSnaps = await FirestoreService.filterItems(
        COLLECTIONS.RIDER_TEAM_MEMBER.NAME,
        [where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.EVENT_ID.KEY, '==', eventId)]
      )

      riderReamMembersSnaps.forEach((current) => {
        riderTeamMembers_.push(RiderTeamMemberModel.fromFirestoreDoc(current).toObject())
      })

      const eventRegisteredUsersSnaps = await FirestoreService.filterItems(
        COLLECTIONS.EVENT_REGISTERED_USERS.NAME,
        [where(COLLECTIONS.EVENT_REGISTERED_USERS.FIELDS.EVENT_ID.KEY, '==', eventId)]
      )

      eventRegisteredUsersSnaps.forEach((currDoc) => {
        eventRegisteredUsers_.push(
          getConvertedData(EventRegisteredUsersModel.fromFirestoreDoc(currDoc).toObject())
        )
      })

      const registeredUsersByDay_ = await RegistrationDyDayService.getByEventIds([eventId])

      const eventFeesSnapShot = await FirestoreService.getItem(COLLECTIONS.EVENT_FEES.NAME, eventId)

      const registrationFees_ = new EventFeesModel(eventFeesSnapShot.data()).toFirestore()

      const horsesSnaps = await FirestoreService.filterItems(COLLECTIONS.HORSES.NAME)
      horsesSnaps.forEach((currDoc) => {
        horsesInDb.push(getConvertedData(HorseModel.fromFirestoreDoc(currDoc).toObject()))
      })

      const usersSnaps = await FirestoreService.filterItems(COLLECTIONS.USERS.NAME)
      usersSnaps.forEach((currDoc) => {
        const current = getConvertedData(UserModel.fromFirestoreDoc(currDoc).toObject())
        usersInDb.push(current)
      })

      // sanitize users by removing sensitive fields, but we need more data for reports than available in public users
      const sanitizedUsers = usersInDb.map((protectedUser) => {
        const {
          userSocialSecurityNumber,
          userStripeAccountId,
          userStripeAccountStatus,
          userStripeId,
          ...sanitizedUserData
        } = protectedUser
        return sanitizedUserData
      })

      setUsers(sanitizedUsers)

      setEvent(event_)
      setRiderTeamMembers(riderTeamMembers_)
      setEventRegisteredUsers(eventRegisteredUsers_)
      setRegisteredUsersByDay(registeredUsersByDay_)
      setRegistrationFees(registrationFees_)
      setHorses(horsesInDb)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error(error)
      toastFunctions.error({
        message: MESSAGES_CONST.EVENT_DATA_NOT_AVAILABLE,
      })
    }
  }

  useEffect(() => {
    getAllData().then()
  }, [eventId])

  return loading ? (
    <div className="flex w-full justify-center items-center">
      <ViewsLoader />
    </div>
  ) : (
    <>
      {activeOption === 'Event Reports' && (
        <EventReportsReport
          event={event}
          eventRegisteredUsers={eventRegisteredUsers}
          registeredUsersByDay={registeredUsersByDay}
          registrationFees={registrationFees}
          scheduleBy={scheduleBy}
          riderTeamMembers={riderTeamMembers}
          activeOption={activeOption}
          customScheduling={customScheduling}
          setActiveOption={setActiveOption}
          horses={horses}
        />
      )}
      {activeOption === 'Event Results' && (
        <EventResultsReport
          event={event}
          registrationFees={registrationFees}
          activeOption={activeOption}
          setActiveOption={setActiveOption}
          registeredUsersByDay={registeredUsersByDay}
          hunterJumperScoreCards={hunterJumperScoreCards}
          eventReviewPublish={eventReviewPublish}
          eventRegisteredUsers={eventRegisteredUsers}
          riderTeamMembers={riderTeamMembers}
          scheduleBy={scheduleBy}
          horses={horses}
          users={users}
        />
      )}
    </>
  )
}

export default ManageClinicReportsRoot
